(() => {
  const TOGGLE_ID = 'ChikasSizeGuideToggle';
  let lastFabric = '';

  const applyFabric = (fabric) => {
    const f = String(fabric || lastFabric || '').toLowerCase();
    const stretch = document.getElementById('chikas-guia-stretch');
    const rigida = document.getElementById('chikas-guia-rigida');
    if (!stretch || !rigida) return;
    if (f.indexOf('rig') >= 0) rigida.checked = true;
    else stretch.checked = true;
  };

  const sync = () => {
    const box = document.getElementById(TOGGLE_ID);
    if (!box) return;
    document.documentElement.classList.toggle('chikas-sg-open', !!box.checked);
    if (box.checked) applyFabric(lastFabric);
  };

  document.addEventListener(
    'click',
    (e) => {
      const trigger = e.target.closest && e.target.closest('[data-chikas-size-guide-open], .size-guide');
      if (!trigger) return;
      lastFabric = trigger.getAttribute('data-guide-fabric') || lastFabric;
      const box = document.getElementById(TOGGLE_ID);
      if (!box) return;
      /* Label con for= ya marca el checkbox; botón/enlace necesita ayuda */
      if (trigger.tagName !== 'LABEL' || trigger.getAttribute('for') !== TOGGLE_ID) {
        e.preventDefault();
        box.checked = true;
      }
      requestAnimationFrame(sync);
    },
    true
  );

  document.addEventListener(
    'change',
    (e) => {
      if (e.target && e.target.id === TOGGLE_ID) sync();
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const box = document.getElementById(TOGGLE_ID);
    if (!box || !box.checked) return;
    box.checked = false;
    sync();
  });

  sync();
})();
